import manvarLogo from '../../../../assets/img/manvar.png'
import jsPDF from "jspdf";
import 'jspdf-autotable';

export const useHelpers = () => {

    const defaultFontSize = 10
    const titleFontSize = 15

    const getCurrentDate = () => {
        const today = new Date(); // Crea un objeto de fecha con la fecha actual
        const year = today.getFullYear(); // Obtiene el año
        const month = today.getMonth() + 1; // Obtiene el mes (getMonth() devuelve un índice basado en cero, por lo que se suma 1)
        const day = today.getDate(); // Obtiene el día del mes

        // Formatea la fecha en 'YYYY-MM-DD', asegurándote de agregar un cero delante de meses y días menores a 10
        return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
    }

    const getCurrentStartMonth = () => {
        const today = new Date(); // Crea un objeto de fecha con la fecha actual
        const year = today.getFullYear(); // Obtiene el año
        const month = today.getMonth() + 1; // Obtiene el mes (getMonth() devuelve un índice basado en cero, por lo que se suma 1)


        // Formatea la fecha en 'YYYY-MM-DD', asegurándote de agregar un cero delante de meses y días menores a 10
        return `${year}-${month < 10 ? `0${month}` : month}-01`;
    }

    // const _drawHeaderReport = (docPdf, data, posY, formatMoney) => {
    //
    //     docPdf.setFont("helvetica", "bold");
    //     docPdf.setFontSize(titleFontSize);
    //     docPdf.text('REPORTE DE MOVIMIENTOS DE CAJA', 110, posY, { align: 'center' });
    //     docPdf.setFontSize(defaultFontSize);
    //
    //     posY += 10;
    //
    //     docPdf.setFont("helvetica", "bold");
    //     docPdf.text('INFORMACIÓN GENERAL', 20, posY, { align: 'left' });
    //     docPdf.line(20, posY + 1, 200, posY + 1);
    //
    //     posY += 8;
    //
    //     docPdf.setFont("helvetica", "bold");
    //     docPdf.text('CAJA: ', 20, posY, { align: 'left' });
    //     docPdf.setFont("helvetica", "normal");
    //     docPdf.text(String(data.descripcion_corta || ''), 45, posY, { align: 'left' });
    //
    //     posY += 6;
    //
    //     const historyEfectivoQ = Number(data.efectivo_historico_quetzales || 0);
    //     const historyEfectivoUSD = Number(data.efectivo_historico_dolares || 0);
    //     docPdf.setFont("helvetica", "bold");
    //     docPdf.text('SALDO HISTORICO: ', 20, posY, { align: 'left' });
    //     docPdf.setFont("helvetica", "normal");
    //     docPdf.text(`Q ${formatMoney(historyEfectivoQ)}`, 70, posY, { align: 'left' });
    //     docPdf.text(`$ ${formatMoney(historyEfectivoUSD)}`, 120, posY, { align: 'left' });
    //
    //     posY += 6;
    //
    //     const efectivoQ = Number(data.efectivo_quetzales || 0);
    //     const efectivoUSD = Number(data.efectivo_dolares || 0);
    //     docPdf.setFont("helvetica", "bold");
    //     docPdf.text('SALDO TOTAL: ', 20, posY, { align: 'left' });
    //     docPdf.setFont("helvetica", "normal");
    //     docPdf.text(`Q ${formatMoney(efectivoQ)}`, 70, posY, { align: 'left' });
    //     docPdf.text(`$ ${formatMoney(efectivoUSD)}`, 120, posY, { align: 'left' });
    //
    //     posY += 6;
    //
    //     const summary = data.summary || null;
    //
    //     if (summary) {
    //         const iQ = Number(summary?.ingresos?.quetzales || 0);
    //         const iU = Number(summary?.ingresos?.dolares || 0);
    //         const eQ = Number(summary?.egresos?.quetzales || 0);
    //         const eU = Number(summary?.egresos?.dolares || 0);
    //         const bQ = Number(summary?.balance?.quetzales || 0);
    //         const bU = Number(summary?.balance?.dolares || 0);
    //
    //         // docPdf.setFont("helvetica", "bold");
    //         // docPdf.text("RESUMEN", 20, posY, { align: 'left' });
    //         // posY += 6;
    //
    //         docPdf.setFont("helvetica", "bold");
    //         docPdf.text("TOTAL INGRESOS:", 20, posY, { align: 'left' });
    //         docPdf.setFont("helvetica", "normal");
    //         docPdf.text(`Q ${formatMoney(iQ)}`, 70, posY, { align: 'left' });
    //         docPdf.text(`$ ${formatMoney(iU)}`, 120, posY, { align: 'left' });
    //
    //         posY += 6;
    //
    //         docPdf.setFont("helvetica", "bold");
    //         docPdf.text("TOTAL EGRESOS:", 20, posY, { align: 'left' });
    //         docPdf.setFont("helvetica", "normal");
    //         docPdf.text(`Q ${formatMoney(eQ)}`, 70, posY, { align: 'left' });
    //         docPdf.text(`$ ${formatMoney(eU)}`, 120, posY, { align: 'left' });
    //
    //         posY += 6;
    //
    //         docPdf.setFont("helvetica", "bold");
    //         docPdf.text("BALANCE (I - E):", 20, posY, { align: 'left' });
    //         docPdf.setFont("helvetica", "normal");
    //         docPdf.text(`Q ${formatMoney(bQ)}`, 70, posY, { align: 'left' });
    //         docPdf.text(`$ ${formatMoney(bU)}`, 120, posY, { align: 'left' });
    //
    //         posY += 10;
    //     } else {
    //         if (Array.isArray(data.totals)) {
    //             for (let i = 0; i < data.totals.length; i++) {
    //                 const t = data.totals[i];
    //
    //                 const tq = Number(t.total_movimiento_quetzales || 0);
    //                 const tu = Number(t.total_movimiento_dolares || 0);
    //
    //                 docPdf.setFont("helvetica", "bold");
    //                 docPdf.text(`TOTAL DE ${t.movimiento_tipo}:`, 20, posY, { align: 'left' });
    //                 docPdf.setFont("helvetica", "normal");
    //                 docPdf.text(`Q ${formatMoney(tq)}`, 70, posY, { align: 'left' });
    //                 docPdf.text(`$ ${formatMoney(tu)}`, 120, posY, { align: 'left' });
    //
    //                 posY += 6;
    //             }
    //             posY += 6;
    //         }
    //     }
    // }
    //
    // const _drawBodyReport = (docPdf, data, posY, formatMoney) => {
    //
    //     docPdf.setFont("helvetica", "bold");
    //     docPdf.text(`MOVIMIENTOS REGISTRADOS ENTRE ${data.fecha_inicio} y ${data.fecha_fin}`, 20, posY, { align: 'left' });
    //     docPdf.line(20, posY + 1, 200, posY + 1);
    //
    //     posY += 10;
    //
    //
    //
    //     const tipo = data?.movimiento_tipo ?? 'ALL';
    //     const movements = Array.isArray(data.movements) ? data.movements : [];
    //     const movementsToPrint =
    //         (tipo === 'ALL') ? movements : movements.filter(m => m.movimiento_tipo === tipo);
    //
    //     docPdf.setFont("helvetica", "bold");
    //     docPdf.text("FECHA", 20, posY, { align: 'left' });
    //     docPdf.text("TIPO", 52, posY, { align: 'left' });
    //     docPdf.text("MONEDA", 82, posY, { align: 'left' });
    //     docPdf.text("CAMBIO", 110, posY, { align: 'left' });
    //     docPdf.text("QUETZALES", 132, posY, { align: 'left' });
    //     docPdf.text("DOLARES", 162, posY, { align: 'left' });
    //     docPdf.line(20, posY + 1, 200, posY + 1);
    //
    //     posY += 8;
    //
    //     for (let i = 0; i < movementsToPrint.length; i++) {
    //         const mov = movementsToPrint[i];
    //         if (posY > 260) {
    //             docPdf.addPage();
    //             posY = 20;
    //         }
    //
    //         const tc = Number(mov.movimiento_tipo_cambio || 0);
    //         const q = Number(mov.movimiento_quetzales || 0);
    //         const usd = Number(mov.movimiento_dolares || 0);
    //
    //         docPdf.setFont("helvetica", "normal");
    //         docPdf.text(String(mov.movimiento_fecha || ''), 20, posY, { align: 'left' });
    //         docPdf.text(String(mov.movimiento_tipo || ''), 52, posY, { align: 'left' });
    //         docPdf.text(String(mov.movimiento_moneda || ''), 82, posY, { align: 'left' });
    //
    //         docPdf.text(`Q ${formatMoney(tc)}`, 110, posY, { align: 'left' });
    //         docPdf.text(`Q ${formatMoney(q)}`, 132, posY, { align: 'left' });
    //         docPdf.text(`$ ${formatMoney(usd)}`, 162, posY, { align: 'left' });
    //
    //         const obs = String(mov.movimiento_observaciones || '');
    //         // Si hay observaciones, las imprimimos debajo del movimiento
    //         const obsLines = docPdf.splitTextToSize(obs, 120);
    //         const obsStartY = posY + 5;
    //         docPdf.text(obsLines, 52, obsStartY);
    //         const obsHeight = obsLines.length * 4;
    //         const totalHeight = 5 + obsHeight;
    //         const endY = posY + totalHeight;
    //         docPdf.setDrawColor(0); // negra
    //         docPdf.setLineWidth(0.2);
    //         docPdf.line(20, endY + 2, 200, endY + 2);
    //         posY = endY + 6;
    //     }
    // }
    //
    // const drawTransactionsReport = (pdfManager, data) => {
    //     const doc = new jsPDF({
    //         orientation: 'portrait',
    //         unit: 'mm',
    //         format: 'letter',
    //     });
    //
    //     _drawHeaderReport(doc, data, 15, formatMoney);
    //     _drawBodyReport(doc, data, 80, formatMoney);
    //
    //     const tipo = data?.movimiento_tipo ?? 'ALL';
    //     const tipoLabel = tipo === 'ALL' ? 'MOVIMIENTOS' : tipo;
    //
    //     // doc.save(`REPORTE ${data.descripcion_corta} ${tipoLabel} ${data.fecha_inicio} A ${data.fecha_fin}.pdf`);
    //     const docName = `REPORTE ${data.descripcion_corta} ${tipoLabel} ${data.fecha_inicio} A ${data.fecha_fin}.pdf`
    //     const docBase64 = doc.output("datauristring").replace(/;filename=[^;]+/, '')
    //
    //     return { docName, docBase64 }
    // }
    //
    //
    const formatMoney = (value) => {
        const num = typeof value === 'string'
            ? parseFloat(value.replace(/,/g, ''))
            : Number(value);

        if (isNaN(num)) return '0.00';

        return num.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

    const convertToFloat = (formattedNumber) => {
        if (formattedNumber === null || formattedNumber === undefined) return 0;

        const cleanedValue = String(formattedNumber).replace(/,/g, '');
        const floatValue = parseFloat(cleanedValue);

        return isNaN(floatValue) ? 0 : floatValue;
    };

    const _drawHeaderReceipt = (docPdf, data, posY, formatMoney) => {
        
        // Marco 
        docPdf.rect(10, 10, 260, 195); // x=10, y=20, ancho=100, alto=50

        // Logo
        const imgWidth = 50; // 50
        const imgHeight = 30; // 30
        // console.log('manvarLogo :::: ', manvarLogo)
        docPdf.addImage(manvarLogo, 'PNG', 20, posY - 15, imgWidth, imgHeight);

        // Membrete principal
        docPdf.setFont("helvetica", "bold");
        docPdf.setFontSize(titleFontSize);
        docPdf.text('GRUPO MANVAR S.A.', 140, posY, { align: 'center' }); // Centrado
        docPdf.setFontSize(defaultFontSize);

        posY += 5

        docPdf.setFont("helvetica", "normal");
        docPdf.text('KILÓMETRO 59.5 CARRETERA A TAXISCO, ESCUINTLA, ESCUINTLA', 140, posY, { align: 'center' });
        docPdf.text('TEL: 2458-1568 extensión 1', 140, posY+5, { align: 'center' });

        posY += 20
        
        // Fecha
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 35, 5, 'F');
        docPdf.rect(20, posY, 80, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('FECHA', 25, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.movimiento_fecha_recibo, 60, posY+4, { align: 'left' });
        
        // // Hora
        // docPdf.setFillColor(230, 230, 230); // RGB gris
        // docPdf.rect(100, posY, 35, 5, 'F');
        // docPdf.rect(100, posY, 80, 5);
        // docPdf.setFont("helvetica", "bold");
        // docPdf.text('HORA', 110, posY+4, { align: 'left' });
        // docPdf.setFont("helvetica", "normal");
        // docPdf.text(data.movimiento_hora_recibo, 140, posY+4, { align: 'left' });
        
        // // Hora
        // docPdf.setFillColor(230, 230, 230); // RGB gris
        // docPdf.rect(180, posY, 35, 5, 'F');
        // docPdf.rect(180, posY, 80, 5);
        // docPdf.setFont("helvetica", "bold");
        // docPdf.text('HORA', 185, posY+4, { align: 'left' });
        // docPdf.setFont("helvetica", "normal");
        // docPdf.text(data.movimiento_hora_recibo, 220, posY+4, { align: 'left' });

        posY += 10

        // // Cliente
        // docPdf.setFillColor(230, 230, 230); // RGB gris
        // docPdf.rect(20, posY, 35, 5, 'F');
        // docPdf.rect(20, posY, 130, 5); //240
        // docPdf.setFont("helvetica", "bold");
        // docPdf.text('CLIENTE', 25, posY+4, { align: 'left' });
        // docPdf.setFont("helvetica", "normal");
        // // docPdf.text(data.info_cliente, 58, posY+4, { align: 'left' });
        
        // // Autoridad
        // docPdf.setFillColor(230, 230, 230); // RGB gris
        // docPdf.rect(150, posY, 35, 5, 'F');
        // docPdf.rect(150, posY, 110, 5);
        // docPdf.setFont("helvetica", "bold");
        // docPdf.text('AUTORIDAD', 155, posY+4, { align: 'left' });
        // docPdf.setFont("helvetica", "normal");
        // // docPdf.text(data.nombre_autoridad, 190, posY+4, { align: 'left' });
        
        posY += 5

        // Operado por
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 35, 5, 'F');
        docPdf.rect(20, posY, 130, 5); //240
        docPdf.setFont("helvetica", "bold");
        docPdf.text('OPERADOR', 25, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.usuario_creo, 58, posY+4, { align: 'left' });
        
        // Por
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(150, posY, 35, 5, 'F');
        docPdf.rect(150, posY, 110, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('POR', 155, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        const moneda = data.movimiento_moneda === 'QUETZAL' ? 'Q. ' : '$ ';
        const monto = parseFloat(data.movimiento_monto).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        docPdf.text(moneda + monto, 190, posY+4, { align: 'left' });
        
        posY += 5

        // // Concepto
        // docPdf.setFillColor(230, 230, 230); // RGB gris
        // docPdf.rect(20, posY, 35, 5, 'F');
        // docPdf.rect(20, posY, 240, 5);
        // docPdf.setFont("helvetica", "bold");
        // docPdf.text('CONCEPTO', 25, posY+4, { align: 'left' });
        // docPdf.setFont("helvetica", "normal");
        // // docPdf.text(`PARQUEO / CONSIGNACIÓN ${data.tarifa_aplicada}`, 58, posY+4, { align: 'left' });

    }

    const _drawIdentifiersReceipt = (docPdf, data, posY, formatMoney) => {

        docPdf.setFont("helvetica", "bold");
        docPdf.setFontSize(defaultFontSize);
        docPdf.text(`TRANSACCIÓN No. ${data.idmovimiento}`, 215, posY+5);

    }

    const _drawInfoReceipt = (docPdf, data, posY, formatMoney) => {

        // Info Pago
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 23, 5, 'F');
        docPdf.rect(20, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('TIPO', 23, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.movimiento_tipo, 45, posY+4, { align: 'left' });

        // Monto
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(73, posY, 23, 5, 'F');
        docPdf.rect(73, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('MONTO', 75, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(parseFloat(data.movimiento_monto).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 97, posY+4, { align: 'left' });

        posY += 5

        // Moneda
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 23, 5, 'F');
        docPdf.rect(20, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('MONEDA', 23, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.movimiento_moneda, 45, posY+4, { align: 'left' });

        // Tipo cambio
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(73, posY, 23, 5, 'F');
        docPdf.rect(73, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('CAMBIO', 75, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(parseFloat(data.movimiento_tipo_cambio || '0').toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 97, posY+4, { align: 'left' });
        
        posY += 5

        // Total Queztales
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 23, 5, 'F');
        docPdf.rect(20, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('TOTAL Q.', 23, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(parseFloat(data.movimiento_quetzales).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 45, posY+4, { align: 'left' });

        // Total Dolares
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(73, posY, 23, 5, 'F');
        docPdf.rect(73, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('TOTAL $.', 75, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(parseFloat(data.movimiento_dolares).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 97, posY+4, { align: 'left' });
        
        posY += 10

        // Cuenta
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 23, 5, 'F');
        docPdf.rect(20, posY, 108, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('CAJA', 23, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.descripcion_caja || '---', 45, posY+4, { align: 'left' });

        posY += 5

        // Banco
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 23, 5, 'F');
        docPdf.rect(20, posY, 108, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('MONEDA', 23, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.currency_type || '---', 45, posY+4, { align: 'left' });
        
        posY += 5

        // Numero de boleta
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 23, 5, 'F');
        docPdf.rect(20, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('SALDO Q.', 23, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(formatMoney(data.saldo_q) || '---', 45, posY+4, { align: 'left' });

        // Referencia ACH
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(73, posY, 23, 5, 'F');
        docPdf.rect(73, posY, 55, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('SALDO $.', 75, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(formatMoney(data.saldo_usd) || '---', 97, posY+4, { align: 'left' });
    }

    const _drawObservationsReceipt = (docPdf, data, justifyTextBox, posY, formatMoney) => {

        // Info Pago
        docPdf.setFillColor(230, 230, 230); // RGB gris
        // docPdf.rect(20, posY, 35, 5, 'F');
        docPdf.rect(180, posY, 80, 70);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('OBSERVACIONES', 183, posY+4, { align: 'left' });
        
        posY += 5
        docPdf.setFont("helvetica", "normal");
        justifyTextBox(docPdf, data.movimiento_observaciones || '', 181, posY+4, 70, {
            fontSize: defaultFontSize,
            fontName: 'helvetica',
            lineSpacing: 5
        })

    }

    const _drawFooterReceipt = (docPdf, data, justifyTextBox, posY, formatMoney) => {
        
        docPdf.line(20, posY, 90, posY);
        docPdf.text(`FIRMA AUTORIZADA`, 40, posY+7, { align: 'left' });
        docPdf.text('SELLO', 125, posY+4, { align: 'left' });

        // posY += 20
        // docPdf.setFont("helvetica", "normal");
        // const text = '*NOTA:* Por cheque rechazado se cobrará en concepto de gastos administrativos: Q150.00 cheques en Quetzales y $20.00 cheques en dólares, quedando anulado este recibo de inmediato. INTERESES Y MORA: Se cobrará 10% sobre la cuota a vigente a cancelar y un monto de Q10.00 diarios en concepto de mora, hasta hacer efectivo el pago correspondiente, este monto podrá variar conforme al contrato vigente o conforme a políticas internas sin previo aviso. Plazo Extemporáneo: Se cobrará Q1,000.00 por me adicional después de vencido el plazo contractual o estipulado por cada negocio.'
        // justifyTextBox(docPdf, text, 20, posY, 240, {
        //     fontSize: defaultFontSize,
        //     fontName: 'helvetica',
        //     lineSpacing: 5
        // })
    }

    const drawTransactionReceipt = (pdfManager, data) => {
        const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
            format: 'letter',
        });

        const { pdfLandscapeDoc, justifyTextBox } = pdfManager

        _drawHeaderReceipt(doc, data, 25, formatMoney);
        _drawIdentifiersReceipt(doc, data, 30, formatMoney)
        _drawInfoReceipt(doc, data, 90, formatMoney)
        _drawObservationsReceipt(doc, data, justifyTextBox, 90, formatMoney)
        _drawFooterReceipt(doc, data, justifyTextBox, 185, formatMoney)

        // const tipo = data?.movimiento_tipo ?? 'ALL';
        // const tipoLabel = tipo === 'ALL' ? 'MOVIMIENTOS' : tipo;

        const docName = `COMPROBANTE.pdf`
        const docBase64 = doc.output("datauristring").replace(/;filename=[^;]+/, '')

        return { docName, docBase64 }
    }

    return Object.freeze({
        getCurrentDate,
        getCurrentStartMonth,
        // drawTransactionsReport,
        formatMoney,
        convertToFloat,
        drawTransactionReceipt
    })
}
